let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lVzwR")).then(() => parcelRequire('lFuBj'));